var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconQuery = function SvgMiconQuery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M11 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 12h-2V8h2a2 2 0 0 0 0-4h-2a2 2 0 0 0-2 2v.5H6V6a4.004 4.004 0 0 1 4-4h2a4 4 0 1 1 0 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M22.448 21.035A10.97 10.97 0 0 0 19.92 4.746l-.999 1.73A8.997 8.997 0 1 1 5 14.002H3a10.991 10.991 0 0 0 18.034 8.447l7.552 7.552L30 28.588z"
  })));
};
export default SvgMiconQuery;